import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { DownloadIcon } from 'air-icons';
import AirButton from 'air-button';
import { Spin } from 'antd';
import { withRouter } from 'react-router-dom';
import { QsHelper } from '../../../../../helpers';
import api from '../../../../../services/api';

import './Export.css';

@withRouter
@inject('translationsStore', 'carsStore', 'filterStore', 'commonStore')
@observer
export default class Export extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingExport: false
    };
  }

  handleClientExport = () => {
    const { translationsStore, carsStore, filterStore, commonStore } = this.props;

    this.setState({ loadingExport: true });

    let filtersCollection = {};
    Object.keys(filterStore.appliedFiltersParameters).map(filterKey => {
      if (['carStatus_filter'].includes(filterKey)) {
        filtersCollection['status'] = filterStore.appliedFiltersParameters[filterKey];
      } else {
        filtersCollection[filterKey.replace('carFilter_', '')] = filterStore.appliedFiltersParameters[filterKey];
      }
    });
    if (commonStore.selectedDealers.length > 0) {
      filtersCollection['dealers'] = commonStore.selectedDealers;
    }
    delete filtersCollection['search.query'];
    const qs = new QsHelper(window.location.search),
      filters = qs.serializeObject({ filters: filtersCollection });

    api('exportCars', { filters, query: carsStore.virtualQuery }).then(response => {
      const exportFilename = 'carlist.csv';
      try {
        const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      } finally {
        this.setState({ loadingExport: false });
      }
    });
  };

  render() {
    const { translationsStore } = this.props;
    const { loadingExport } = this.state;
    return (
      <Spin spinning={loadingExport}>
        <AirButton
          disabled={loadingExport}
          className="export"
          icon={<DownloadIcon />}
          label={translationsStore.translate('carList.export.title')}
          onClick={this.handleClientExport}
        />
      </Spin>
    );
  }
}
